import { IconSVG } from '../types';

export const Logout = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      style={style}
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M20.15 13H9a.967.967 0 01-.713-.287A.968.968 0 018 12c0-.283.096-.52.287-.713A.967.967 0 019 11h11.15l-.85-.85a.916.916 0 01-.288-.7c.009-.267.105-.5.288-.7.2-.2.438-.304.712-.313a.93.93 0 01.713.288L23.3 11.3c.2.2.3.433.3.7 0 .267-.1.5-.3.7l-2.575 2.575a.93.93 0 01-.713.287 1.02 1.02 0 01-.712-.312c-.183-.2-.28-.433-.288-.7a.916.916 0 01.288-.7l.85-.85zM15 8V5H5v14h10v-3c0-.283.096-.52.287-.713A.968.968 0 0116 15c.283 0 .52.096.712.287.192.192.288.43.288.713v3c0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0115 21H5c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 013 19V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 015 3h10c.55 0 1.02.196 1.413.587C16.803 3.98 17 4.45 17 5v3c0 .283-.096.52-.288.713A.968.968 0 0116 9a.968.968 0 01-.713-.287A.967.967 0 0115 8z"
      />
    </svg>
  );
};
